export const imageUrl = 'https://image.tmdb.org/t/p/';

export const api = {
  apiKey: process.env.REACT_APP_API_KEY,
  url: 'https://api.themoviedb.org/3/',
  discover: 'discover/movie',
  trending: 'trending/all/day',
  movie: 'movie',
  search: 'search/movie',
};

export const backdropSize = {
  s: 'w300',
  m: 'w780',
  l: 'w1280',
  o: 'original',
};

export const posterSize = {
  s: 'w500',
  m: 'w780',
  l: 'original',
};
